"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.L2ToL2BonderFeeBps = exports.L2ToL1BonderFeeBps = exports.GasPriceMultiplier = exports.LpFeeBps = exports.BondTransferGasLimit = exports.TokenIndex = exports.Chain = exports.Network = void 0;
var Network;
(function (Network) {
    Network["Mainnet"] = "mainnet";
    Network["Staging"] = "staging";
    Network["Goerli"] = "goerli";
    Network["Kovan"] = "kovan";
})(Network = exports.Network || (exports.Network = {}));
var Chain;
(function (Chain) {
    Chain["Ethereum"] = "ethereum";
    Chain["Optimism"] = "optimism";
    Chain["Arbitrum"] = "arbitrum";
    Chain["Polygon"] = "polygon";
    Chain["xDai"] = "xdai";
})(Chain = exports.Chain || (exports.Chain = {}));
var TokenIndex;
(function (TokenIndex) {
    TokenIndex[TokenIndex["CanonicalToken"] = 0] = "CanonicalToken";
    TokenIndex[TokenIndex["HopBridgeToken"] = 1] = "HopBridgeToken";
})(TokenIndex = exports.TokenIndex || (exports.TokenIndex = {}));
var BondTransferGasLimit;
(function (BondTransferGasLimit) {
    BondTransferGasLimit["Ethereum"] = "165000";
    BondTransferGasLimit["Optimism"] = "100000000";
})(BondTransferGasLimit = exports.BondTransferGasLimit || (exports.BondTransferGasLimit = {}));
exports.LpFeeBps = '4';
exports.GasPriceMultiplier = '1.6';
exports.L2ToL1BonderFeeBps = '18';
exports.L2ToL2BonderFeeBps = '30';
